import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

/* eslint-disable no-console */

@Injectable({
  providedIn: 'root',
})
export class SensorDynamicLoaderService {
  constructor(private _matDialog: MatDialog) {}

  /**
   * Dynamically loads and opens the SensorDeviceOnboardingComponent dialog
   * Used by TeaserComponent for sensor device onboarding
   */
  public async openSensorDeviceOnboardingDialog(): Promise<void> {
    try {
      const module = await import('../../sensordaten/dialog/sensor-device-onboarding/sensor-device-onboarding.component');
      const SensorDeviceOnboardingComponent = module.SensorDeviceOnboardingComponent;

      this._matDialog.open(SensorDeviceOnboardingComponent, {
        disableClose: true,
        autoFocus: false,
        panelClass: 'ep-generic-dialog',
        minWidth: '822px',
      });
    } catch (error) {
      console.error('Failed to load sensor device onboarding component:', error);
      // Handle error gracefully - component could not be loaded
    }
  }

  /**
   * Dynamically loads and opens the SensorOnboardingComponent dialog
   * Used by MeterTableComponent for sensor onboarding
   * Returns a promise that resolves with the dialog result
   */
  public async openSensorOnboardingDialog(data?: any): Promise<boolean> {
    try {
      const module = await import('../../sensordaten/components/sensor-onboarding/sensor-onboarding.component');
      const SensorOnboardingComponent = module.SensorOnboardingComponent;

      const dialogRef = this._matDialog.open(SensorOnboardingComponent, {
        panelClass: 'sensor-onboarding-dialog',
        disableClose: true,
        autoFocus: true,
        data: data, // Pass any data that might be needed
      });

      // Return the result from the dialog
      const result = await dialogRef.afterClosed().toPromise();
      return result === true; // Return boolean indicating if onboarding was successful
    } catch (error) {
      console.error('Failed to load sensor onboarding component:', error);
      return false; // Return false on error
    }
  }

  /**
   * Dynamically loads sensor types store service
   * Used by services that need sensor type data
   */
  public async loadSensorTypesStore(): Promise<any> {
    try {
      const sensorModule = await import('../../sensordaten/services/sensor-type-data-store.service');
      return sensorModule.SensorTypeDataStoreService;
    } catch (error) {
      console.error('Failed to load sensor types store:', error);
      return null;
    }
  }

  /**
   * Dynamically loads sensor models and types
   * Returns interfaces to avoid direct imports
   */
  public async loadSensorTypes(): Promise<any[]> {
    try {
      const sensorModule = await import('../../sensordaten/models/sensor-type.model');
      // Return empty array as fallback, actual implementation would depend on requirements
      return [];
    } catch (error) {
      console.error('Failed to load sensor types:', error);
      return []; // Graceful fallback
    }
  }
}
